export function XML_Param6(paramID, param1, param2, param3, param4, param5, param6, xmlCanvas) {
  var s = xmlCanvas.GetStream();
  xmlCanvas.OutputElementSex(paramID, param1, param2, param3, param4, param5, param6, s);
}
